import { Navigate, useLocation } from "react-router-dom";

import { DEAL_ROOM_PREFIX, LEGACY_ROOM_PREFIX } from "@/deal-room/room-path";

// /rooms/... was the room path until 2026-09-18. Same page, query string and
// hash under /deal-room/...; a component rather than a loader redirect because
// a loader never sees the hash (#task-<id>, #capabilities-<id> deep links).
export function LegacyRoomRedirect() {
    const { pathname, search, hash } = useLocation();
    const to = DEAL_ROOM_PREFIX + pathname.slice(LEGACY_ROOM_PREFIX.length) + search + hash;
    return <Navigate to={to} replace />;
}
